import type { IValidatedResponse } from '../../httpClient';
import { postRequest } from '../../httpClient';
import type { ISetupTelegramMenuButtonResponse } from './setup-telegram-menu-button-response';
import { setupTelegramMenuButtonResponseSchema } from './setup-telegram-menu-button-response';

export async function setupTelegramMenuButtonApi(): Promise<
  IValidatedResponse<ISetupTelegramMenuButtonResponse>
> {
  return postRequest<ISetupTelegramMenuButtonResponse>({
    path: '/sys/telegram/setup-menu-button',
    schema: setupTelegramMenuButtonResponseSchema,
  });
}
